import { render, staticRenderFns } from "./reportWrap.vue?vue&type=template&id=33ecdab7&scoped=true&"
import script from "./reportWrap.vue?vue&type=script&lang=js&"
export * from "./reportWrap.vue?vue&type=script&lang=js&"
import style0 from "./reportWrap.vue?vue&type=style&index=0&id=33ecdab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ecdab7",
  null
  
)

export default component.exports